import { __extends } from "tslib";
import React from 'react';
import { WrapperItem } from '../components/wrapper-item';
import { Section } from '../components/section';
import { Column } from '../components/column';
import { shorthand } from '../utils/css-utils';
import { GenericImageWithSplitResolutionsForOutlook } from './generic-image';
var SectionLogo = /** @class */ (function (_super) {
    __extends(SectionLogo, _super);
    function SectionLogo() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SectionLogo.prototype.render = function () {
        var _a, _b;
        var _c = this.props, section = _c.section, cssClass = _c.cssClass, columnCssClass = _c.columnCssClass;
        var outerPadding = section.outerPadding, innerPadding = section.innerPadding, srcNonRetina = section.srcNonRetina;
        return (React.createElement(WrapperItem, null,
            React.createElement(Section, { backgroundColor: section.backgroundColor, cssClass: cssClass + " html-email-logo-" + section.backgroundSize + "-layout", textAlign: "center", borderBottom: section.borderBottom, borderLeft: section.borderLeft, borderRight: section.borderRight, borderTop: section.borderTop, padding: shorthand(outerPadding) },
                React.createElement(Column, { padding: shorthand(innerPadding), cssClass: "html-email-logo-column-" + section.backgroundSize + "-layout " + columnCssClass, backgroundColor: (_a = section.columnProps) === null || _a === void 0 ? void 0 : _a.backgroundColor, innerBackgroundColor: (_b = section.columnProps) === null || _b === void 0 ? void 0 : _b.innerBackgroundColor },
                    React.createElement(GenericImageWithSplitResolutionsForOutlook, { src: section.src, srcNonRetina: srcNonRetina, align: section.align, cssClass: "so-global-region-logo-content", href: section.href, maxHeight: section.imageSize + "px", alt: "", showAfterLoad: true })))));
    };
    return SectionLogo;
}(React.Component));
export { SectionLogo };
//# sourceMappingURL=section-logo.js.map